angular.module('gym.components').directive('signedWaiverCollapsiblePanel', function() {
  return {
    restrict: 'EA',
    transclude: true,
    scope: {
      collapsible: '=',
      defaultCollapsed: '=',
      title: '='
    },
    template: require('templates/components/waivers/signed_waiver_collapsible_panel.html.slim'),
    controller: ["$scope", function($scope) {
      $scope.collapsed = $scope.defaultCollapsed;
      return $scope.toggle = function() {
        if ($scope.collapsible) {
          return $scope.collapsed = !$scope.collapsed;
        }
      };
    }]
  };
});
